/* eslint-disable no-param-reassign */
export default {
  state: {
    queryMsg: {
      keyword: '', // 搜索
      sort_rule: 'update_time_sort'
    },
    modelView: 'table'
  },
  mutations: {
    set_keyword: (state, data) => {
      state.queryMsg.keyword = data
    },
    set_sort_rule: (state, data) => {
      state.queryMsg.sort_rule = data
    },
    set_mod_view: (state, data) => {
      state.modelView = data
    },
    clear_queryMsg: (state, data) => {
      state.queryMsg = {
        keyword: '', // 搜索
        sort_rule: 'update_time_sort'
      }
      state.modelView = 'table'
    }
  },
  getters: {},
  actions: {}
}
